// src/components/BlockedWords.tsx
import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../store";
import "./BlockedWords.css";
import { BlockedWordsViewModel, deleteBlockedWord, fetchBlockedWords } from "./blockedWordsSlice";
import { ColDef, ICellRendererParams } from "ag-grid-community";

// Main Component
const BlockedWordsOption: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { data, loading, error } = useSelector((state: RootState) => state.blockedWords);
  const [gridApi, setGridApi] = useState<any>(null);

  useEffect(() => {
    if (data.length === 0) {
      dispatch(fetchBlockedWords());
    }
  }, [dispatch, data.length]);

  const onGridReady = (params: any) => {
    setGridApi(params.api);
    params.api.sizeColumnsToFit();
  };

  const handleDelete = async (id: number) => {
    try {
      await dispatch(deleteBlockedWord(id)); // Dispatch delete action
      alert(`Blocked word with ID ${id} deleted successfully.`);
      dispatch(fetchBlockedWords()); // Refresh the list after deletion
    } catch (error) {
      console.error(`Failed to delete blocked word with ID ${id}:`, error);
    }
  };
  
  // Column Definitions
  const columnDefs: ColDef<BlockedWordsViewModel>[] = [
    {
      headerName: "Text",
      field: "text",
      sortable: true,
      filter: true,
      flex: 1,
    },
    {
      headerName: "Create Date",
      field: "createDate",
      sortable: true,
      filter: true,
      flex: 1,
      sort: "desc", // Sort descending initially
      sortIndex: 0, // First column to apply sorting
      valueFormatter: (params) => new Date(params.value).toLocaleString(), // Format the date
    },
    {
      headerName: "Is Title",
      field: "isTitle",
      sortable: true,
      filter: true,
      flex: 1,
      cellRenderer: (params: ICellRendererParams) => (params.value ? "Yes" : "No"), // Render Yes/No
    },
    {
      headerName: "Actions",
      field: "id",
      cellRenderer: (params: ICellRendererParams) => (
        <button
          onClick={() => handleDelete(params.value)}
          style={{ padding: "5px 10px", cursor: "pointer" }}
        >
          Delete
        </button>
      ),
      flex: 1,
    },
  ];

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className="ag-theme-alpine" style={{ height: 600, width: "100%" }}>
      <AgGridReact
             rowData={data}
             columnDefs={columnDefs}
             onGridReady={onGridReady}
             pagination={true}
             paginationPageSize={50} // Adjust for mobile usability
             domLayout="autoHeight" // Ensures grid adjusts height based on rows
             animateRows={true} // Adds smooth row animations
             suppressHorizontalScroll={false} // Allows horizontal scrolling
             defaultColDef={{
               resizable: true, // Allow resizing of columns
               autoHeight: true, // Adjust height dynamically
             }}
           />
    </div>
  );
};

export default BlockedWordsOption;
